import React from "react";
import { Tabel } from "../../../core";
const CHANGE_DATE_FORMAT = require("../../../helper/utils/datFormat");
const columns = [
  {
    title: "SR #",
    dataIndex: "SNo",
    key: "S.No",
    width: 150,
  },
  {
    title: "No of Beams",
    dataIndex: "noofbeams",
    key: "noofbeams",
    width: 150,
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (text, record, index) => {
      return (
        <span>
          {/* {record.invoice_date}
          <br /> */}
          {CHANGE_DATE_FORMAT.changeDateFormat(record.date)}
        </span>
      );
    },
    width: 150,
  },
];

const BeamDeliveryDate = ({ data }) => {
  return (
    <Tabel pagination={false} nowidth={false} columns={columns} data={data} />
  );
};

export default BeamDeliveryDate;
